<div *ngIf="showErrorMessage" class="alert alert-danger" role="alert">
  Yazıcı servisleri aktif değil
  <a href="#" (click)="downloadAndInstall()">
    <i class="fa fas fa-download"></i> Buraya tıklayarak</a> {{ 'link.download-windows-app' | translate }}
  <button type="button" class="btn-close" aria-label="Close" (click)="closeErrorMessage()">

  </button>
</div>